import ApplicationMobile from './container'

export default ApplicationMobile